<!--
 * @Description:日期选择框，重写日期后缀
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-03-13 10:36:41
 * @LastEditors: mdb
-->
<template>
  <a-date-picker
    style="width: 100%"
    :showTime="showTime"
    v-model:value="time"
    v-bind="$attrs"
    :valueFormat="formFormat"
    @ok="ok"
  />
</template>
<script lang="ts">
import { computed, ref, watch } from 'vue'
import dayjs from 'dayjs'
import { Form } from 'ant-design-vue'
import { toBeijingTime } from '@/utils/timeFormat'
export default { name: 'CosRangePicker' }
</script>
<script setup lang="ts">
const formItemContext = Form.useInjectFormItemContext()
const props = defineProps({
  value: {
    type: String
  },
  showTime: {
    type: [Boolean, Object],
    default: false
  },
  valueFormat: String,
  // 输出北京时间
  isOutputBeijingTime: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:value', 'ok'])
const time = ref<any>([])
const resultTime = ref()
watch(
  () => props.value,
  (v, prev) => {
    if (v && !resultTime.value) {
      time.value = dayjs(v)
    } else if (!v) {
      time.value = undefined
    }
  },
  { immediate: true }
)
const formFormat = computed(() => {
  return props.valueFormat ? props.valueFormat : props.showTime ? 'YYYY/MM/DD HH:mm:ss' : 'YYYY/MM/DD'
})
const ok = () => {
  const format = props.valueFormat ? props.valueFormat : props.showTime ? 'YYYY/MM/DD HH:mm:ss' : 'YYYY/MM/DD'
  const rtime = dayjs(time.value).format(format)
  resultTime.value = rtime
  const emitValue = props.isOutputBeijingTime ? toBeijingTime(rtime) : rtime
  emit('update:value', emitValue)
  emit('ok')
  formItemContext.onFieldChange()
}
</script>
